import React from 'react';
import LookerReport from './LookerReport';

const FlightSearchAnalytics = () => {
  return <LookerReport source="flight_search" title="Flight Search Analytics" />;
};

export default FlightSearchAnalytics;